<template>
  <div
    class="slide"
    :class="{
      'slide_white': white,
      'slide_mobile': isMobile,
      'slide_extra-mobile': isExtraMobile,
    }"
  >
    <div
      class="slide__wrap"
      :style="{
        'width': maxWidth+'px',
        'max-width': maxWidth+'px',
      }"
    >
      <div
        v-if="isMobile || !right"
        class="slide__text"
      >
        <div v-if="title" class="slide__sub-title">{{ title }}</div>
        <div
          v-for="string in strings"
          class="slide__article slide__items"
        >
          <div class="slide__li-wrap">
            <div class="slide__li"></div>
          </div>
          <div
            v-html="string"
            class="slide__string"
          ></div>
        </div>
        <slot></slot>
      </div>
      <div class="slide__media">
        <div class="slide__media-main">
          <img
            :src="image"
            class="slide__media-img"
          >
        </div>
        <div
          v-for="image in smallImages"
          class="slide__media-small"
        >
          <img
            :src="image"
            class="slide__media-small-img"
          >
        </div>
      </div>
      <div v-if="!isMobile && right" class="slide__text slide__text_right">
        <div v-if="title" class="slide__sub-title">{{ title }}</div>
        <div
          v-for="string in strings"
          class="slide__article slide__items"
        >
          <div class="slide__li-wrap">
            <div class="slide__li"></div>
          </div>
          <div
            v-html="string"
            class="slide__string"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maxWidth: {type: Number, default: 1300},
    image: {type: String, default: null},
    smallImages: {type: Array, default: () => []},
    white: {type: Boolean, default: false},
    right: {type: Boolean, default: false},
    title: {type: String, default: null},
    strings: {type: Array, default: () => []},
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isExtraMobile() {
      return this.$vuetify.breakpoint.xs;
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/vars.scss';

.slide {
  display: flex;
  justify-content: center;

  &.slide_mobile {
    &.slide_extra-mobile {
      .slide__media-small {
        width: 100px;
      }
    }
    .slide__wrap {
      flex-direction: column;
    }
    .slide__media {
      margin-top: 30px;
    }
    .slide__media-small {
      width: 130px;
    }
    .slide__text {
      width: 100%;
    }
    .slide__sub-title {
      margin-top: 0;
    }
    .slide__title {
      margin-top: 0;
    }
  }
  &.slide_white {
    background-color: #fff;
  }
  .slide__wrap {
    display: flex;
    align-items: center;
    padding: 40px 20px;
  }
  .slide__text {
    width: 40%;
    padding-right: 40px;

    &.slide__text_right {
      padding-right: 0;
      padding-left: 40px;
    }
  }
  .slide__media {
    position: relative;
    padding-bottom: 30px;
    padding-left: 30px;
    flex: 1;
  }
  .slide__media-img {
    width: 100%;
    display: block;
  }
  .slide__media-main {
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 2px 2px 7px #5e5e5e;
  }
  .slide__media-small {
    width: 180px;
    max-height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 2px 2px 7px #5e5e5e;
  }
  .slide__media-small-img {
    max-width: 100%;
    display: block;
  }
  .slide__title {
    font-size: 32px;
    line-height: 38px;
    font-weight: 300;
    margin: 0 0 30px 0;
  }
  .slide__sub-title {
    font-size: 24px;
    line-height: 20px;
    font-weight: 300;
    margin: 34px 0;
    color: #3b4252;
  }
  .slide__article {
    font-size: 19px;
    margin: 15px 0;
    font-weight: 300;
  }
  .slide__mark {
    font-weight: 300;
    color: #57617a;
    margin: 5px 0;
    font-size: 19px;

    .v-icon {
      margin-right: 10px;
      font-size: 30px;
      color: #57617a;
    }
  }
  .slide__li {
    width: 18px;
    height: 18px;
    background-color: $colorPrimary;
    border-radius: 50%;
    margin-top: 4px;
    margin-right: 20px;
  }
  .slide__string {
    flex: 1;
  }
  .slide__items {
    display: flex;
  }
}
</style>